import * as React from "react"
import { Context } from "@contexts/SpaceAllPlacesCtx.tsx"

const useSpaceAllPlacesCtx = () => React.useContext(Context)

export default useSpaceAllPlacesCtx
